interface IProps {
	children: JSX.Element[];
}

export default function CalendarBoardGrid({children}: IProps) {
	const result: JSX.Element[] = [];
	for (let i = 0; i < children.length; i += 7) {
		result.push(<div key={i} className="flex flex-row">
			{children.slice(i, i + 7).map((child, index) => <div key={index} className="grow w-0">{child}</div>)}
		</div>);
	}
	return (
		<div className="flex flex-col">
			{
				result
			}
		</div>
	);
}
